import React, { Children, cloneElement, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useSettings } from '@vmos2/providers';
import { UpdateApp } from '@vmos2/cordova';
import { BackgroundPortal, HeaderContext } from '@vmos2/design-system';

type Props = {
  children: React.Node,
};

export const Container = ({ children }: Props) => {
  const theme = useTheme();
  const headerRef = useRef();
  const wrapperRef = useRef(null);
  const { nativeAppForceUpdate } = useSettings();
  const [background, setBackgroundRef] = useState(null);

  return (
    <HeaderContext.Provider value={headerRef}>
      <UpdateApp forceUpdate={nativeAppForceUpdate}>
        <Wrapper ref={wrapperRef}>
          <ContentContainer>
            {Children.map(children, child => cloneElement(child, { background, theme, wrapperRef }))}
          </ContentContainer>
          <BackgroundPortal ref={setBackgroundRef} />
        </Wrapper>
      </UpdateApp>
    </HeaderContext.Provider>
  );
};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  line-height: ${({ theme }) => theme.lineHeight};
  flex-direction: column;
  height: 100%;
`;

const ContentContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
  padding-bottom: var(--native-footer-height, 0);
`;
